import { DestroyRef, ElementRef, Signal, afterNextRender, inject, signal } from '@angular/core';

/**
 * MD3 window classes, measured on the element itself rather than the window: the side navigation
 * takes up to 280px, so the band's width is what decides the layout (#856).
 */
export type BandSize = 'compact' | 'narrow' | 'medium' | 'wide';

export function bandSizeOf(width: number): BandSize {
  if (width < 600) return 'compact';
  if (width < 840) return 'narrow';
  if (width < 1200) return 'medium';
  return 'wide';
}

/**
 * The host's {@link BandSize}, following its width. A container query would do for the CSS alone,
 * but the band also switches templates (the bottom sheet), which CSS cannot.
 */
export function observeBandSize(
  host: ElementRef<HTMLElement> = inject(ElementRef),
): Signal<BandSize> {
  const size = signal<BandSize>('wide');
  const destroyRef = inject(DestroyRef);

  afterNextRender(() => {
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(([entry]) => size.set(bandSizeOf(entry.contentRect.width)));
    observer.observe(host.nativeElement);
    destroyRef.onDestroy(() => observer.disconnect());
  });

  return size.asReadonly();
}
